import styled, { css } from 'styled-components';

export const MatchRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.1em;
  min-height: 2em;
  width: 100%;
  padding: 0.33em 0;
  border-bottom: 1px dashed ${props => props.theme.colors.mediumDarkGray};
`;

export const MatchRowLink = styled.a`
  :link, :visited {
    text-decoration: none;
  }
  ${props => props.disableLink && css`
    pointer-events: none !important;
    cursor: default !important;
  `
}
`;



// WEBPACK FOOTER //
// ./src/components/StandingRowDashed/styles.js